module.exports = __webpack_public_path__ + "static/img/07.1651215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/07.jpg
// module id = Qzfp
// module chunks = 1